// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-tabsa[data-v-52e90806]{position:fixed;z-index:100}", ""]);
// Exports
module.exports = exports;
